import $ from 'jquery'

export default () => {
    const { detect } = require('detect-browser')
    const browser = detect()

    if (browser.name == 'ios' || browser.name == 'ie' || browser.name == 'edge') {
        $('body').addClass('is-' + browser.name)
    }
}
